import React, { memo, forwardRef } from "react";
const SvgNumberseven = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M15.54 22.62c-.173.347-.373.58-.6.7-.227.12-.433.18-.62.18-.333 0-.627-.107-.88-.32-.24-.227-.36-.533-.36-.92 0-.093.007-.2.02-.32.027-.12.087-.273.18-.46l5.16-10.16h-6.08c-.253 0-.46-.04-.62-.12a1.225 1.225 0 01-.38-.28 1.07 1.07 0 01-.16-.36 1.493 1.493 0 01-.04-.32c0-.093.013-.2.04-.32a.883.883 0 01.16-.34c.093-.12.22-.22.38-.3.16-.08.367-.12.62-.12h7.2c.347 0 .62.053.82.16.213.107.373.233.48.38.12.133.193.273.22.42.04.147.06.267.06.36 0 .133-.013.28-.04.44-.027.147-.087.32-.18.52l-5.38 11.18z"
      />
    </svg>
  );
});
SvgNumberseven.displayName = "SvgNumberseven";
const MemoForwardRef = memo(SvgNumberseven);
export default MemoForwardRef;
